import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type SecretVisibilityAlreadyEncryptedErrorOptions = {
  secret: ObjectId;
};

export class SecretVisibilityAlreadyEncryptedError extends FleekError<SecretVisibilityAlreadyEncryptedErrorOptions> {
  public name = 'SecretVisibilityAlreadyEncryptedError';

  toString = () => {
    return 'You cannot change visibility of already encrypted secret.';
  };
}
